import { render, staticRenderFns } from "./batch_image.vue?vue&type=template&id=7a000c50&scoped=true"
import script from "./batch_image.vue?vue&type=script&lang=js"
export * from "./batch_image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a000c50",
  null
  
)

export default component.exports